export default __webpack_public_path__ + "static/media/p1-slice3-m.7568f77a.png";